import {
  GET_STATES_REQUEST,
  GET_STATES_SUCCESS,
  GET_STATES_FAILURE,
} from './actionTypes';

const getStatesReducer = (state = { data: {} }, {
  type, data, error,
}) => {
  switch (type) {
    case GET_STATES_REQUEST:
      return {
        ...state,
        data: {},
        isLoading: true,
      };
    case GET_STATES_SUCCESS:
      return {
        ...state,
        data,
        isLoading: false,
      };
    case GET_STATES_FAILURE:
      return {
        ...state,
        isLoading: false,
        error,
      };
    default:
      return state;
  }
};

export default getStatesReducer;
